var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activated
    ? _c("div", [
        _c("div", { staticClass: "global-navi-wallet" }, [
          _c("div", { staticClass: "global-navi-wallet-list" }, [
            _c("ul", [
              _c("li", { staticClass: "global-navi-wallet-list-coin" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "analytics",
                        rawName: "v-analytics",
                        value: { label: "side_menu_mypoint" },
                        expression: "{label:'side_menu_mypoint'}",
                      },
                    ],
                    attrs: { href: _vm.coinPointLink },
                  },
                  [
                    _c("p", { staticClass: "global-navi-wallet-icon-coin" }, [
                      _vm._v("コイン"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "global-navi-coin" },
                      [
                        _c("coin-balance", {
                          staticClass: "global-navi-wallet-coin",
                        }),
                        _vm._v("C"),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "global-navi-wallet-list-point" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "analytics",
                        rawName: "v-analytics",
                        value: { label: "side_menu_mypoint" },
                        expression: "{label:'side_menu_mypoint'}",
                      },
                    ],
                    attrs: { href: _vm.coinPointLink },
                  },
                  [
                    _c("p", { staticClass: "global-navi-wallet-icon-point" }, [
                      _vm._v("ポイント"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "global-navi-point" },
                      [
                        _c("point-balance", {
                          staticClass: "global-navi-wallet-point",
                        }),
                        _vm._v("P"),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "global-navi-wallet-list-coupon" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "analytics",
                        rawName: "v-analytics",
                        value: { label: "side_menu_coupon" },
                        expression: "{label:'side_menu_coupon'}",
                      },
                    ],
                    attrs: { href: _vm.couponLink },
                  },
                  [
                    _c("p", { staticClass: "global-navi-wallet-icon-coupon" }, [
                      _vm._v("クーポン"),
                    ]),
                    _vm._v(" "),
                    _c("coupon-balance", {
                      staticClass: "global-navi-wallet-coupon",
                    }),
                    _vm._v("枚\n          "),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }